import { defineComponent } from 'vue';

/**
 * Allows for reversal of DOM elements. Useful in cases where there's a slight difference in element for mobile vs. desktop in designs.
 */
export default defineComponent({
	functional: true,
	props: {
		/**
		 * Reverses order of children
		 */
		reverse: Boolean,
	},
	render(_, ctx) {
		const children = ctx.slots().default;
		if (ctx.props.reverse) {
			children.reverse();
		}

		return children;
	}
});